/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { UserProfileContext } from 'auth/contexts/UserProfileContext';

import { SEARCH_REDUCERS } from 'state/reducers/search/searchReducers';
import { AUTOCOMPLETE_REDUCERS } from 'state/reducers/autocomplete/autocompleteReducers';

import { tagTokenPrefix } from 'state/services/searchApiUtils';
import PatientSearchField from 'views/components/Search/PatientSearchField';
import PatientSearchForm from './KardiaRxPatientCCTSearchForm';
import {
  searchSubmit,
  getKardiaRxCCTPatientsData,
  clearPageLimit,
  slectedValueONSubmitClear,
} from '../../state/KardiaRxCCTPatient/KardiaRxCCTPatientsActions';

import styles from './KardiaRxPatientCCTSearch.css';

class KardiaRxPatientCCTSearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchType: '',
      searchParams: {
        page: 1,
      },
      tagRemoved: null,
    };
  }

  handleSearchTypeChange = searchType => {};

  handleSubmit = values => {
    if (values && values.patients) {
      const valueArray = values.patients.split(' [');
      const mrnIdentifier =
        valueArray[1] && valueArray[1].substring(0, valueArray[1].length - 1);
      if (mrnIdentifier) {
        const mrnValue = mrnIdentifier.split(':')[1];
        this.props.getKardiaRxCCTPatientsData(false, 1000, 1, mrnValue);
      } else {
        this.props.getKardiaRxCCTPatientsData(false, 1000, 1, values.patients);
      }
    } else {
      this.props.getKardiaRxCCTPatientsData();
    }
    const data = {
      values,
      pageLimit: 1000,
    };
    this.props.searchSubmit(data);
  };

  handleRemoveTag = (field, value) => {
    this.props.slectedValueONSubmitClear();
    this.props.clearPageLimit();
    this.props.getKardiaRxCCTPatientsData();
    // this.setState({
    //   tagRemoved: { field: value },
    // });
    // this.props.changeFieldValue(field, value);
    // this.props.dispatch(formSubmit(SEARCH_FORM_REDUCERS.PATIENT_SEARCH));
  };

  // eslint-disable-next-line no-unused-vars
  onFormChange = (values, previousValues) => {};

  render() {
    const { searchType, searchParams } = this.state;
    const {
      patientSearchResults,
      autocompleteResults,
      isFetching,
    } = this.props;
    // const { participants } = autocompleteResults;
    // const autocompleteLoading = autocompleteResults.isFetching === true;
    return (
      <div>
        <PatientSearchForm
          onFormChange={this.onFormChange}
          selectedSearchType={searchType}
          selectedOptionValues={this.props.selectedOptionValues}
          styles={styles}
          isSubmitting={patientSearchResults.isFetching === true}
          onSubmit={this.handleSubmit}
          onSearchTypeChange={this.handleSearchTypeChange}
          searchFieldComponent={
            <PatientSearchField
              placeholder="Patient name / MRN"
              isLoading={isFetching}
              autocompleteData={autocompleteResults}
              styles={styles}
              defaultValue={searchParams.patients}
              tokenPrefix={tagTokenPrefix}
              onRemoveTag={this.handleRemoveTag}
            />
          }
        />
      </div>
    );
  }
}
KardiaRxPatientCCTSearchBar.contextType = UserProfileContext;

// setup up redux search store
const mapStateToProps = ({ search, autocomplete, kardiaRx }) => {
  return {
    patientSearchResults: search[SEARCH_REDUCERS.INFINITE_SCROLL_REDUCER],
    autocompleteResults:
      kardiaRx.kardiaRxCCTPatients.kardiaRxCCTAutoCompleteSearch,
    autocompleteForceRefresh:
      autocomplete[AUTOCOMPLETE_REDUCERS.AUTOCOMPLETE_FORCE_REFRESH],
    selectedOptionValues: kardiaRx.kardiaRxCCTPatients.filterDropdownlist.data,
    isFetching: kardiaRx.kardiaRxCCTPatients.patients.isFetching,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    searchSubmit,
    getKardiaRxCCTPatientsData,
    clearPageLimit,
    slectedValueONSubmitClear,
  })(KardiaRxPatientCCTSearchBar),
);



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxPatientCCTSearch/KardiaRxPatientCCTSearchBar.jsx